import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children, subNav = null }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-background'>
            <Header subNav={subNav} />

            <main className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
